export const eventCreateConfig = (createSelectOptions) => {
  return [
    {
      step_title: 'Event Information',
      form_title: 'Create An Event',
      section: [
        {
          name: 'name',
          input: 'text',
          placeholder: 'Enter Name',
          rules: [
            {
              required: true,
              message: 'Event name is required',
            },
          ],
        },
        {
          name: 'from_date',
          input: 'date',
          placeholder: 'Enter Date',
          rules: [
            {
              required: true,
              message: 'Date is required',
            },
          ],
        },
        {
          name: 'to_date',
          input: 'date',
          placeholder: 'Enter Date',
          rules: [
            {
              required: true,
              message: 'Date is required',
            },
          ],
        },
        {
          name: 'type',
          input: 'text',
          placeholder: 'Enter type',
          rules: [
            {
              required: true,
              message: 'Type is required',
            },
          ],
        },
        {
          name: 'adjustment_factor',
          input: 'text',
          placeholder: 'Enter Adjustment Factor',
          rules: [
            {
              required: true,
              message: 'Adjustment factor is required',
            },
          ],
        },
        {
          name: 'market',
          input: 'text',
          placeholder: 'Enter Market',
          rules: [
            {
              required: true,
              message: 'Market is required',
            },
          ],
        },
        {
          name: 'store',
          input: 'select',
          type: 'single',
          placeholder: 'Select Store',
          options: createSelectOptions?.stores ? ['All', ...createSelectOptions.stores] : [],
          rules: [
            {
              required: true,
              message: 'Store is required',
            },
          ],
        },
        {
          name: 'product_group',
          input: 'select',
          type: 'single',
          placeholder: 'Select Product Group',
          options: createSelectOptions?.groups ? ['All', ...createSelectOptions.groups] : [],
          rules: [
            {
              required: true,
              message: 'Product group is required',
            },
          ],
        },
        {
          name: 'product',
          input: 'select',
          type: 'single',
          placeholder: 'Select Product',
          options: createSelectOptions?.products ? ['All', ...createSelectOptions.products] : [],
          rules: [
            {
              required: true,
              message: 'Product is required',
            },
          ],
        },
      ],
    },
  ]
}
